import axios from "axios";

const saberes = {
  state: () => ({
    saberes: [],
    saber: {},
  }),

  getters: {
    obtenerSaberes(state) {
      return state.saberes;
    },
    
    obtenerSaber(state) {
      return state.saber;
    },
   
  },

  mutations: {
    enviarSaberes(state, saberes) {
      state.saberes = saberes;
    },

    enviarSaber(state, saber) {
      state.saber = saber;
    },
  },

  actions: {
    registrarSaber(context, saber) {
      return new Promise((resolve, reject) => {
        axios.post(`/api/campesena/categorias/${saber.categoria_id}/saberes`, saber)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
      });
    },

    gestionarSaberesCampesena(context, idCategoria) {
      axios.get(`/api/campesena/categorias/${idCategoria}/saberes`)
        .then((response) => {
          const saberes = [];
          response.data.results.forEach((saber) => {
            saberes.push({
              id: saber.id_saber,
              saber: saber.saber,
              descripcion: saber.descripcion,
              categoria_id: saber.categoria_id,
            });
          });
          context.commit("enviarSaberes", saberes);
        })
        .catch(() => {});
    },

    obtenerSaberCampesenaId(context, { idCompetencia, idSaber }) {
        axios
          .get(`api/campesena/categorias/${idCompetencia}/saberes/${idSaber}`)
          .then((response) => {
            const results = response.data.results
    
            const saber ={
              id: results.id_saber,
              saber: results.saber,
              descripcion: results.descripcion,
              categoria_id: results.categoria_id,
            }
            context.commit("enviarSaber",saber );
          })
          .catch(() => { });
    },

    actualizarSaberCampesena(context, {idCategoria, idSaber,saber}) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/campesena/categorias/${idCategoria}/saberes/${idSaber}`, saber)
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },
    
    eliminarSaberCampesena(context, {id_categoria, id_saber}) {
        return new Promise((resolve, reject) => {
            axios.delete(`api/campesena/categorias/${id_categoria}/saberes/${id_saber}`)
            .then((response) => {
                resolve(response.data)
            })
            .catch(() => {
                reject()
            })
        })
    },
  },
};

export default saberes;
